// extracted by mini-css-extract-plugin
export var blackText = "style-module--blackText--32904";
export var lineThrough = "style-module--lineThrough--b5b2a";
export var oekoIcon = "style-module--oekoIcon--703ae";
export var reduction = "style-module--reduction--d9937";
export var reductionValue = "style-module--reductionValue--4b378";
export var totalAmount = "style-module--totalAmount--f95fa";
export var totalAmountValue = "style-module--totalAmountValue--32465";